// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"521":"navigation","552":"rules","809":"users","945":"dashboard","952":"interface","966":"login","972":"creation"}[chunkId] || chunkId) + ".3.2.0.js";
};